module.exports = __webpack_public_path__ + "static/img/downloadbg.efe3c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/downloadbg.png
// module id = ld+x
// module chunks = 3